export default __webpack_public_path__ + "static/sprue-7abb6acfa9828f4bce35c0520b2b0286.png";